import { IgnoreIcon } from '@rsos/assets/icons';
import {
  Box,
  Button,
  FakeLinkComponent,
  Text,
} from '@rsos/components/capstone/base';
import { useSelectedAlert } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import { requestSAML } from '@rsos/sinatra';
import { useAppDispatch } from '../../app';

interface RemoveAlertProps {
  onRemoveAlertFromQueue: () => void;
}

const RemoveAlert = ({ onRemoveAlertFromQueue }: RemoveAlertProps) => {
  const dispatch = useAppDispatch();

  const currentAlert = useSelectedAlert();

  const isSupplementalOnly = currentAlert?.supplemental_only;

  const handleTrainingLink = () => {
    dispatch(requestSAML('training', 'alerts-training'));
  };

  return (
    <>
      <Button
        btnType="tertiary"
        name="alarm-remove-btn"
        onClick={onRemoveAlertFromQueue}
        size="small"
      >
        <IgnoreIcon width={20} height={20} />
        <Text inline size="small">
          Remove from Queue
        </Text>
      </Button>
      {isSupplementalOnly && (
        <Box horizontal justify="center" padding="5px">
          <Text
            color="primaryText"
            fontWeight="bold"
            inline
            marginRight="5px"
            size="small"
            textTransform="uppercase"
          >
            Supplemental Only.
          </Text>
          <FakeLinkComponent
            onClick={handleTrainingLink}
            size="small"
            type="secondary"
          >
            Learn more about Alerts →
          </FakeLinkComponent>
        </Box>
      )}
    </>
  );
};

export default RemoveAlert;
